import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=5d12499d&scoped=true&"
import script from "./administration.vue?vue&type=script&lang=js&"
export * from "./administration.vue?vue&type=script&lang=js&"
import style0 from "./administration.vue?vue&type=style&index=0&id=5d12499d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12499d",
  null
  
)

export default component.exports